import * as L from 'lodash';
import moment from 'moment';
import { createStringEnum } from '@EnumUtils';
import { Item, MakeCorporatePassRequest } from '@api';
import { IshState } from 'src/js/services/IshState';
import { BuildCheckoutModelRequest } from '../../../services/CheckoutService';

export const FieldName = createStringEnum([
  'creditCardName',
  'creditCardNumber',
  'expiryMonth',
  'expiryYear',
  'creditCardCvv',
  'agreementFlag',
]);
export type FieldName = keyof typeof FieldName;

export interface CreditCardFormValues {
  creditCardName?: string;
  creditCardNumber?: string;
  expiryMonth?: string;
  expiryYear?: string;
  creditCardCvv?: string;
  agreementFlag: boolean;
}

export interface CorporatePassFormValues {
  reference: string;
  purchaseOrder?: string;
  agreementFlag: boolean;
}

export class PaymentService {
  static months = (): Promise<Item[]> => {
    const result = L.range(1, 13).map((i) => {
      const v = i < 10 ? `0${i}` : `${i}`;
      return { key: v, value: v };
    });
    return Promise.resolve(result);
  };

  static years = (): Promise<Item[]> => {
    const start: number = moment().get('year');
    const result = L.range(start, start + 11).map((y) => {
      const v = `${y}`;
      return { key: v, value: v };
    });
    return Promise.resolve(result);
  };

  static corporatePassValuesToRequest = async (values, state: IshState): Promise<MakeCorporatePassRequest> => ({
    agreementFlag: values.agreementFlag,
    reference: values.reference || null,
    checkoutModelRequest: await BuildCheckoutModelRequest.fromState(state),
    corporatePassId: state.checkout.payment.corporatePass.id
  });
}
